import { MultiSelectEventType } from '../enums';

const MultiSelectEvents = {
  computed: {
    displayValue() {
      return this.convertedOptions
        .filter((option) => this.value.includes(option.value))
        .map((option) => option.text)
        .join(', ');
    },
    convertedOptions() {
      return this.getConvertedOptions(this.options);
    },
  },
  methods: {
    handleOptionClick(optionValue) {
      const isSelected = this.getIsOptionSelected(optionValue);
      const newValue = isSelected
        ? this.removeValue(optionValue)
        : this.addValue(optionValue);

      return this.$emit(MultiSelectEventType.Change, newValue);
    },
    addValue(newValue) {
      return [...this.value, newValue];
    },
    removeValue(removedValue) {
      return this.value.filter((item) => item !== removedValue);
    },
    getIsOptionSelected(value) {
      return this.value.includes(value);
    },
  },
};

export default MultiSelectEvents;
